import React, { useEffect, useState } from "react";
import { Header } from "semantic-ui-react";
import Add from "./add";

import { useLocation } from "react-router";

import Edit from "./edit";
import Preview from "./preview/index";
import Filters from "./filters";

import { useSelector } from "react-redux";
import { selectTranslations } from "../../config/i18n/slice";
import { usePermissionsSimplified } from "../../../hooks/usePermissionsSimplified";
import { useHistory } from "react-router-dom";
import {
  PlusIcon,
  WorkOrderIcon,
  WorkOrderKanbarHeaderBlue,
  WorkOrderKanbarHeaderGreen,
  WorkOrderKanbarHeaderGrey,
  WorkOrderKanbarHeaderPurple,
  WorkOrderKanbarHeaderRed,
  WorkOrderKanbarHeaderYellow,
} from "../../../Assets/Icons/svg";
import KanbarHeader from "./kanbarHeader";
import Animation from "../../components/common/CustomLoader";
import { getAllWorkOrders } from "../../config/api/workOrderApis";
import { isPastDue, isStartDue } from "../../config/date-utils";
const KanbarView = () => {
  const { userPermissions } = usePermissionsSimplified();
  const history = useHistory();

  const [modalWidth, setModalWidth] = useState(
    Math.max(window.innerWidth / 2, 514)
  );

  const t = useSelector(selectTranslations);
  const organisationId = useSelector((state) => {
    if (state?.auth?.user?.organisation) {
      return state.auth.user.organisation.id;
    } else {
      return null;
    }
  });
  const currentUserLocations = useSelector((state) => {
    if (state?.auth?.user?.id) {
      return state.auth.user.locations;
    } else {
      return null;
    }
  });

  const currentUserId = useSelector((state) => {
    if (state?.auth?.user?.id) {
      return state.auth.user.id;
    } else {
      return null;
    }
  });

  const selectedLanguage = useSelector((state) => {
    if (state?.i18n?.lang) {
      return state.i18n.lang;
    } else {
      return "en";
    }
  });

  const role = useSelector((state) => {
    if (state?.auth?.user?.id) {
      return state.auth.user.role.type;
    } else {
      return null;
    }
  });

  const allIds = [];

  currentUserLocations?.length &&
    currentUserLocations.forEach((location) => {
      if (!allIds.some((inv) => inv == location?.id)) {
        allIds.push(location?.id);
      }
    });
  const curentUrl = useLocation();
  const [seriesEdit, setSeriesEdit] = useState(false);

  const queryParams = new URLSearchParams(curentUrl.search);
  const [totalPartCount, setTotalPartCount] = useState({});
  const workOrderId = queryParams.get("id");
  const [selectedDates, setSelectedDates] = useState([]);
  const [toggleAsideModal, setToggleAsideModal] = useState(false);
  const [fetching, setFetchLoading] = useState(true);
  const [data, setData] = useState([]);
  const [initData, setInitData] = useState([]);
  const [targetedData, setTargetedData] = useState();
  const [togglePreview, setTogglePreviw] = useState(false);
  const [toggleEditModal, setToggleEditModal] = useState(false);

  const [refresh, setRefresh] = useState(false);

  /* The above code is a React useEffect hook that fetches work orders data asynchronously using the
`getAllWorkOrders` function with the `organisationId` parameter. It then updates the state variables
`initData`, `data`, `fetchLoading`, `targetedData`, and `togglePreview` based on the fetched data
and conditions. The useEffect hook runs whenever the `refresh` or `workOrderId` dependencies change. */
  useEffect(() => {
    const fetchData = async () => {
      const fetchData = await getAllWorkOrders(
        organisationId,
        "",
        1,
        99999,
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        "",
        [],
        [],
        role,
        [],
        currentUserId
      );

      if (fetchData.response) {
        setInitData(fetchData.response);
        setData(fetchData.response);
        setFetchLoading(false);
        if (workOrderId) {
          let selectedWorkOrder = fetchData.find(
            (each) => each?.attributes?.countId == workOrderId
          );
          if (selectedWorkOrder) {
            setTargetedData(selectedWorkOrder);
            setTogglePreviw(true);
          }
        }
      }
    };

    fetchData();
  }, [refresh, workOrderId]);

  const statusOptions = [
    {
      value: "open",
      color: "blue",
      label: t.workOrders.work_order_status.open,
      svg: <WorkOrderKanbarHeaderBlue />,
    },
    {
      value: "inProgress",
      color: "yellow",
      label: t.workOrders.work_order_status.inProgress,
      svg: <WorkOrderKanbarHeaderYellow />,
    },
    {
      value: "onHold",
      color: "red",
      label: t.workOrders.work_order_status.onHold,
      svg: <WorkOrderKanbarHeaderRed />,
    },
    {
      value: "inReview",
      color: "green",
      label: t.workOrders.work_order_status.inReview,
      svg: <WorkOrderKanbarHeaderGreen />,
    },
    {
      value: "completed",
      color: "darkblue",
      label: t.workOrders.work_order_status.completed,
      svg: <WorkOrderKanbarHeaderGrey />,
    },
    {
      value: "reOpen",
      color: "light-purple",
      label: t.workOrders.work_order_status.reOpen,
      svg: <WorkOrderKanbarHeaderPurple />,
    },
  ];
  const categoryOptions = [
    {
      value: "damage",
      label: t.workOrders.form.category_options[0],
    },
    {
      value: "corrective action Downtime",
      label: t.workOrders.form.category_options[1],
    },
    {
      value: "planned Downtime",
      label: t.workOrders.form.category_options[2],
    },
    {
      value: "unplanned Downtime",
      label: t.workOrders.form.category_options[3],
    },
    {
      value: "inspection",
      label: t.workOrders.form.category_options[4],
    },
    {
      value: "electrical",
      label: t.workOrders.form.category_options[5],
    },
    {
      value: "mechanical",
      label: t.workOrders.work_order_category.Mechanical,
    },
    {
      value: "HVAC",
      label: t.workOrders.work_order_category.HVAC,
    },
    {
      value: "preventive maintenance",
      label: t.workOrders.form.category_options[8],
    },
    {
      value: "project",
      label: t.workOrders.form.category_options[9],
    },
    {
      value: "safety",
      label: t.workOrders.work_order_category.Safety,
    },
    {
      value: "sop",
      label: t.workOrders.form.category_options[11],
    },
  ];

  const handleSetDataByFilter = (newData) => {
    setData(newData);
  };

  let statusFilteredData = {
    open: [],
    inProgress: [],
    onHold: [],
    inReview: [],
    completed: [],
    reOpen: [],
  };

  data.map((one) => {
    switch (one?.attributes?.status) {
      case "open":
        statusFilteredData.open.push(one);
        break;
      case "inProgress":
        statusFilteredData.inProgress.push(one);
        break;
      case "onHold":
        statusFilteredData.onHold.push(one);
        break;
      case "inReview":
        statusFilteredData.inReview.push(one);
        break;
      case "completed":
        statusFilteredData.completed.push(one);
        break;
      case "reOpen":
        statusFilteredData.reOpen.push(one);
        break;
    }
  });

  return (
    <>
      <div className="workOrder new-listing-container table-header-dashboard stick-header pb-5">
        <div className="header-actions">
          <Header className="procedure-title mt-5" as="h2">
            {" "}
            <WorkOrderIcon />
            {t.workOrders.title}
          </Header>
          <div></div>

          {userPermissions?.["work-order"]?.create ? (
            <button
              onClick={() => {
                setToggleAsideModal(true);
              }}
              type="button"
              className="add-button"
            >
              <span className="add-button-text">
                {t.workOrders.details_view.work_order_no}
              </span>
              <span className="add-button-img">
                <PlusIcon />
              </span>
            </button>
          ) : null}
        </div>

        {initData?.length > 0 ? (
          <div className="new-listing-filter wo-filter sticky-filter mt-8">
            <Filters
              data={initData}
              setSelectedDates={setSelectedDates}
              selectedDates={selectedDates}
              setDataByFilter={handleSetDataByFilter}
              hasStatus={false}
              fileData={data}
              setRefresh={setRefresh}
              refresh={refresh}
              allIds={allIds}
              roleData={role}
              currentUserId={currentUserId}
            />
          </div>
        ) : null}
      </div>
      <div className="workOrder-container new-listing-container">
        {fetching ? (
          <div className="animation-div d-flex justify-content-center align-items-center">
            <Animation />
          </div>
        ) : (
          <div>
            {initData?.length > 0 ? (
              <div className="new-listing-filter">
                <>
                  <div className="kanbar-view-container d-flex">
                    {statusOptions.map((one) => {
                      return (
                        <KanbarHeader
                          color={one.color}
                          name={one.label}
                          svg={one.svg}
                          data={statusFilteredData[one.value]}
                          orderClick={(order) => {
                            setTargetedData(order);
                            setTogglePreviw(true);
                          }}
                        />
                      );
                    })}
                  </div>
                </>
              </div>
            ) : (
              <div className="text-center">
                <Header as="h2">{t.workOrders.no_work_orders_available}</Header>
                <Header as="h3">{t.workOrders.press_to_add_work_orders}</Header>
              </div>
            )}
          </div>
        )}

        {/*  WO add modal */}
        <Add
          allIds={allIds}
          currentUserId={currentUserId}
          roleData={role}
          toggled={toggleAsideModal}
          untoggle={() => {
            setToggleAsideModal(false);
            setModalWidth(Math.max(window.innerWidth / 2, 514));
          }}
          setRefresh={setRefresh}
          setModalWidth={setModalWidth}
          modalWidth={modalWidth}
          refresh={refresh}
        />

        {/*  WO edit modal */}
        <Edit
          roleData={role}
          currentUserId={currentUserId}
          allIds={allIds}
          toggled={toggleEditModal}
          setSeriesEdit={setSeriesEdit}
          seriesEdit={seriesEdit}
          untoggle={() => {
            setToggleEditModal(false);
            setModalWidth(Math.max(window.innerWidth / 2, 514));
            setTargetedData();
            history.push("work-orders-kanban-view");
          }}
          setRefresh={setRefresh}
          refresh={refresh}
          targetedData={targetedData}
        />

        {/*  WO view modal */}
        <Preview
          targetedData={targetedData}
          setTotalPartCount={setTotalPartCount}
          totalPartCount={totalPartCount}
          setModalWidth={setModalWidth}
          currentUserId={currentUserId}
          modalWidth={modalWidth}
          edit={() => {
            setTogglePreviw(false);
            setToggleEditModal(true);
          }}
          toggled={togglePreview}
          untoggle={() => {
            setTargetedData();
            setTogglePreviw(false);
            setModalWidth(Math.max(window.innerWidth / 2, 514));
            history.push("work-orders-kanban-view");
          }}
          negative={isPastDue(
            targetedData?.attributes?.dueDate +
              "T" +
              targetedData?.attributes?.dueTime
          )}
          startDue={isStartDue(
            targetedData?.attributes?.status,
            targetedData?.attributes?.startDate
          )}
          setRefresh={setRefresh}
          refresh={refresh}
          setSeriesEdit={setSeriesEdit}
          seriesEdit={seriesEdit}
        />
      </div>
    </>
  );
};

export default KanbarView;
